<template>
  <div id="app">
    <router-view @userUpdated="setUser" :user="user" />
    <app-footer />
  </div>
</template>

<script>
import AppFooter from '@/components/AppFooter';

export default {
  components: {
    AppFooter
  },

  data() {
    return {
      user: {}
    }
  },

  mounted() {
    if (!Object.keys(this.user).length && localStorage.getItem('user')) {
      this.setUser();
    }
  },

  methods: {
    setUser: function () {
      let storedUser = JSON.parse(localStorage.getItem('user'));

      if (storedUser) {
        this.user = storedUser;
      }
    }
  }
}
</script>
